import { action, observable } from "mobx";
import _ from "lodash";
import { DomainStore } from "./domainStore";
import { toastError } from "../domain/errorHandling/toaster";
import { lazyObservable } from "../domain/helpers/lazyLoad";
import { getServices } from "./persistence/persistServices";

export class ServicesStore {
  rootStore: DomainStore;
  constructor(rootStore: DomainStore) {
    this.rootStore = rootStore;
  }
  @observable
  services = lazyObservable<IService[]>((sink, onError) => {
    getServices()
      .then((items) => {
        sink(observable(items));
        this.rootStore.servicesStore.addLegacySegmentService();
      })
      .catch((e) => {
        toastError({
          message: "Error while loading services.",
          extra: e,
        });
        onError(e);
      });
  });

  getById(serviceId: string) {
    const services = this.services.current();
    if (!services) {
      return undefined;
    }
    return _.find(services, (service) => service.id === serviceId);
  }

  /**
   * Add legacy segment service to the list of services, if the account has access to it.
   */
  @action
  addLegacySegmentService() {
    const items = this.services.current();
    if (!items) {
      return;
    }
    if (
      this.rootStore?.accountStore?.account?.flags?.hasSetupLegacySegmentService
    ) {
      // make sure the service is not already in the list
      if (_.find(items, (service) => service.id === "segment-legacy")) {
        return;
      }

      // add just after the non-legacy segment service
      const segmentServiceIndex = _.findIndex(
        items,
        (service) => service.name === "segment"
      );
      if (segmentServiceIndex === -1) {
        return;
      }

      // add the legacy segment service after the non-legacy one
      items.splice(segmentServiceIndex + 1, 0, {
        ...items[segmentServiceIndex],
        id: "segment-legacy",
        humanName: "Segment.com (Legacy)",
      });
    }
  }
}
